export function subscribeToEmitter(eventEmitter, events, listener) {
  Object.keys(events).forEach(eventName => {
    eventEmitter.on(eventName, args => {
      listener(eventName, events[eventName], args);
    });
  });
}



// WEBPACK FOOTER //
// ./statistics/subscribe-to-emitter.ts